export default __webpack_public_path__ + "static/media/activeMasterData.e198f086.svg";